// src/pages/NasvetiBlog.tsx
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import SectionHeading from '@/components/SectionHeading';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ScrollToTop from '@/components/ScrollToTop';
import BlogPostCard from '@/components/BlogPostCard';
import { blogPosts } from '@/data/blogPosts';
import Head from '@/components/Head';

const NasvetiBlog = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 4;
  
  const totalPages = Math.ceil(blogPosts.length / postsPerPage);
  
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = blogPosts.slice(indexOfFirstPost, indexOfLastPost);
  
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  return (
    <div className="min-h-screen">
      <Head 
        title="Nasveti in članki | Kamen d.o.o."
        description="Preberite koristne nasvete in novice iz sveta keramike, kamna in pultov."
        keywords="keramika nasveti, kamen nasveti, pulti vzdrževanje, nasveti za dom, blog"
      />
      <Navbar />
      <ScrollToTop />
      
      <main className="py-24">
        <div className="container-custom">
          <SectionHeading 
            title="Nasveti in članki"
            subtitle="Preberite koristne nasvete in novice iz sveta keramike, kamna in pultov"
          />
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-10">
            {currentPosts.map((post) => (
              <BlogPostCard key={post.id} post={post} />
            ))}
          </div>
          
          {totalPages > 1 && (
            <div className="flex justify-center mt-12">
              <nav className="flex items-center space-x-2">
                <Button 
                  variant="outline"
                  size="icon"
                  onClick={() => paginate(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                  className="text-secondary border-secondary hover:bg-secondary hover:text-white disabled:opacity-50"
                >
                  <ChevronLeft className="h-4 w-4" />
                </Button>
                
                {Array.from({ length: totalPages }).map((_, index) => (
                  <Button
                    key={index}
                    variant={currentPage === index + 1 ? "default" : "outline"}
                    size="icon"
                    onClick={() => paginate(index + 1)}
                    className={
                      currentPage === index + 1 
                        ? "bg-secondary hover:bg-secondary/90 text-white" 
                        : "border-secondary text-secondary hover:bg-secondary hover:text-white"
                    }
                  >
                    {index + 1}
                  </Button>
                ))}
                
                <Button 
                  variant="outline"
                  size="icon"
                  onClick={() => paginate(Math.min(totalPages, currentPage + 1))}
                  disabled={currentPage === totalPages}
                  className="text-secondary border-secondary hover:bg-secondary hover:text-white disabled:opacity-50"
                >
                  <ChevronRight className="h-4 w-4" />
                </Button>
              </nav>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NasvetiBlog;